import { CustomFieldDataTypeItem } from './CustomFieldDataTypeItem'

export const Text = new CustomFieldDataTypeItem({
  id: 'D5922360-1615-47EA-BC1D-CC609E881D41',
  name: 'Text',
  description: 'A simple text field',
  dataType: 'string',
})
export const Date = new CustomFieldDataTypeItem({
  id: '2F3FECB4-C607-4C38-9A81-C5BAA969C6CF',
  name: 'Date',
  description: 'A date selector',
  dataType: 'Date',
})
export const Number = new CustomFieldDataTypeItem({
  id: 'DDE7B8A8-52EA-4F37-8ACC-3ED7B680C1F9',
  name: 'Number',
  description: 'a simple number field',
  dataType: 'number',
})
export const Entity = new CustomFieldDataTypeItem({
  id: 'E33BE1EB-F0A2-4F9C-BD01-E93613E3E750',
  name: 'Record Link',
  description: 'a hyperlink from one supported record to another in CIMS',
  dataType: 'EntityCustomFieldValue',
})
export const Report = new CustomFieldDataTypeItem({
  id: '5F82A263-31A9-45FB-8719-64B20A0FACB2',
  name: 'Report',
  description:
    'a hyperlink to generate and download a specific report on demand',
  dataType: 'ReportCustomFieldValue',
})
export const List = new CustomFieldDataTypeItem({
  id: 'F0C204AF-C8EC-4CA5-A284-695AF2701D84',
  name: 'List',
  description: 'a dropdown, or set of checkboxes, with pre-defined text values',
  dataType: ['ListCustomFieldValue', 'BooleanListCustomFieldValue'],
})
export const Boolean = new CustomFieldDataTypeItem({
  id: '45CE0F16-3007-4A56-9A59-6288CDEC1985',
  name: 'Checkbox',
  description: 'a simple checkbox',
  dataType: 'boolean',
})
